import EditCardPersonalInfo from './EditCardPersonalInfo';

export default EditCardPersonalInfo;
